module.exports = __webpack_public_path__ + "static/media/sDavis.43c9f4d5.jpeg";